import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export interface RenderedContract {
  key: string;
  title: string;
  description: string;
  content: string;
}

export function useRenderedContract(key: string) {
  return useQuery<RenderedContract | null>({
    queryKey: ["contract", key],
    queryFn: async () => {
      try {
        const res = await api.get<RenderedContract>(`/api/store/contracts/${key}`);
        return res.data;
      } catch (e) {
        const err = e as { response?: { status?: number } };
        if (err.response?.status === 404) return null; // pasif/yok
        throw e;
      }
    },
    staleTime: 5 * 60 * 1000,
  });
}
